import { render, staticRenderFns } from "./step-test-phone.vue?vue&type=template&id=93805a50&scoped=true"
import script from "./step-test-phone.vue?vue&type=script&lang=js"
export * from "./step-test-phone.vue?vue&type=script&lang=js"
import style0 from "./step-test-phone.vue?vue&type=style&index=0&id=93805a50&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93805a50",
  null
  
)

export default component.exports